<template>
      <cleave class="a-input"
            :options="options"
            v-model="raw"
            @blur="onBlur">
    </cleave>
</template>

<script>
  import Cleave from 'vue-cleave-component'

  export default {
    name: 'InputFloat',

    props: {
      value: [String,Number],
      positiveOnly: {
        type: Boolean,
        default: true
      },
      maxDigits: {
        type: Number,
        default: 15
      }
    },

    data: () => ({
      _value: undefined,
    }),

    computed: {
      options: {
        get: function() {
          return {
            numeral: true,
            delimiter: ' ',
            numeralPositiveOnly: this.positiveOnly,
            numeralIntegerScale: this.maxDigits,
            numeralDecimalScale: 3
          }
        }
      },

      raw: {
        get: function() {
          return this.value;
        },

        set: function(value) {
          this._value = value;
          if (value != this.value) {
            this.$emit('input', value);
          }
        }
      }
    },

    components: { Cleave },

    methods: {
      onBlur() {
        this.$emit('blur');
        this.$emit('change', this._value);
      }
    }
  }
</script>

<style scoped>

</style>
